import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import translation_en from "./locales/en.json"
import translation_es from "./locales/es.json"
import translation_fr from "./locales/fr.json"
import translation_nl from "./locales/nl.json"
import translation_de from "./locales/de.json"
import translation_it from "./locales/it.json"

export const SUPPORTED_LANGUAGES = ["en", "es", "fr", "nl", "de", "it"]

const languageDetectorOptions = {
	order: ["localStorage", "navigator"],
	lookupLocalStorage: "i18nextLng",
	caches: ["localStorage"],
}

i18n.use(initReactI18next)
	.use(LanguageDetector)
	.init({
		resources: {
			en: { translation: translation_en },
			es: { translation: translation_es },
			fr: { translation: translation_fr },
			nl: { translation: translation_nl },
			de: { translation: translation_de },
			it: { translation: translation_it },
		},
		fallbackLng: "en",
		supportedLngs: SUPPORTED_LANGUAGES,
		interpolation: {
			escapeValue: false,
		},
		detection: languageDetectorOptions,
	})
